export const roles = {
  ADMIN: "ADMIN",
  POLLSTER: "POLLSTER",
};
export const TOKEN_NAME = "ENCUESTAPP";
export const TOKEN_SURVEYS = "ENCUESTAPP_SURVEYS";
